// When adding Panorama to an existing platform, import the client from the platform fe-essentials, for example in the Viewer you should use:
import {panoramaClientFactory, PanoramaPlatform} from '@wix/fe-essentials-viewer-platform/panorama-client';
import {getGlobalConfig} from './panoramaGlobalConfig';
import type {PanoramaClientFactory} from '@wix/panorama-client';

export const getPanoramaFactory = (
  uuid: string,
  msid: string,
  isPanoramaEnabled: boolean
): PanoramaClientFactory | null => {
  return isPanoramaEnabled
    ? panoramaClientFactory({
        baseParams: {
          platform: PanoramaPlatform.Viewer,
          fullArtifactId: 'com.wixpress.wixstores-client-product-widget',
          componentId: 'com.wixpress.wixstores-client-product-widget',
          uuid,
          msid,
          appDefId: '1380b703-ce81-ff05-f115-39571d94dfcd',
        },
      }).withGlobalConfig(getGlobalConfig())
    : null;
};
